<template>
  <div class="payment2">
    <div class="page-title">参赛报名费</div>

    <van-loading v-if="loading" class="loading" type="spinner" vertical>加载中...</van-loading>

    <template v-else>
      <div class="card">
        <div class="card-main">
          <div class="logo">
            <img v-if="player.avatar" :src="imageView(player.avatar)" alt="" />
            <img v-else src="@/assets/player-default.png" alt="" />
          </div>
          <div class="info">
            <div class="name">{{ player.trueName || '-' }}</div>
            <div class="minor">{{ playerAgeText }}</div>
          </div>
        </div>

        <div class="kv">
          <div class="row">
            <span class="label">参加赛事</span>
            <span class="value">{{ match.unionMatchName || match.chineseName || '-' }}</span>
          </div>
          <div class="row">
            <span class="label">组别</span>
            <span class="value">{{ match.group || match.matchGroupName || '-' }}</span>
          </div>
          <div class="row">
            <span class="label">队伍</span>
            <span class="value">{{ team.name || team.teamName || '-' }}</span>
          </div>
          <div class="row">
            <span class="label">金额</span>
            <span class="value price">￥{{ amountText }}</span>
          </div>
        </div>
      </div>

      <div class="section-title">支付方式</div>
      <div class="pay-methods">
        <van-radio-group v-model="payMethod">
          <van-cell-group inset>
            <van-cell clickable @click="payMethod = 'wechat'">
              <template #title>
                <div class="cell-title">
                  <span>微信支付</span>
                </div>
              </template>
              <template #right-icon>
                <van-radio name="wechat" />
              </template>
            </van-cell>
            <van-cell v-if="couponList.length > 0" clickable @click="payMethod = 'discount'">
              <template #title>
                <div class="cell-title">
                  <span>参赛券抵扣</span>
                  <span class="minor-text">剩余：{{ couponList.length }}</span>
                </div>
              </template>
              <template #right-icon>
                <van-radio name="discount" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>

      <div class="bottom-bar">
        <div class="sum">
          <span class="sum-label">订单金额：</span>
          <span class="sum-value">￥{{ amountText }}</span>
        </div>
        <van-button class="pay-btn" type="info" @click="onPay">支付</van-button>
      </div>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import { Loading, RadioGroup, Radio, Cell, CellGroup, Button, Toast } from 'vant'
import { getBMMatchTeamSignup, getMyMatchPlayerSignupCouponTicketList, bangsaishiCreatePlayerSignupOrder, getWechatPrepayInfo } from '@/api/match'
import { QNImageUtil, UrlUtil, isWeChatMiniApp } from '@/utils'
import { AppType } from '@/constants/appType'
import { ConstConfig } from '@/constants'
import { getWXInfo, removeToken } from '@/libs/cookie-storage'
import wx from 'weixin-js-sdk'

Vue.use(Loading).use(RadioGroup).use(Radio).use(Cell).use(CellGroup).use(Button).use(Toast)

export default {
  name: 'Payment2',
  data() {
    return {
      teamId: '',
      playerId: '',
      matchId: '',
      orderId: '',
      redirectUrl: '',
      loading: false,
      payMethod: 'wechat',
      couponList: [],
      match: {},
      team: {},
      player: {},
      amountFen: 0
    }
  },
  computed: {
    amountText() {
      const n = Number(this.amountFen) / 100
      if (!Number.isFinite(n)) return '0.00'
      return n.toFixed(2)
    },
    playerAgeText() {
      const b = this.player.bmBirthday || this.player.birthday
      if (!b) return ''
      const birth = new Date(b)
      if (Number.isNaN(birth.getTime())) return ''
      const now = new Date()
      let age = now.getFullYear() - birth.getFullYear()
      const m = now.getMonth() - birth.getMonth()
      if (m < 0 || (m === 0 && now.getDate() < birth.getDate())) age -= 1
      if (!Number.isFinite(age) || age < 0) return ''
      return `${age}岁`
    }
  },
  mounted() {
    this.teamId = this.$route.query.teamId || ''
    this.playerId = this.$route.query.playerId || ''
    this.matchId = this.$route.query.matchId || ''
    this.redirectUrl = ''
    this.fetchInfo()
  },
  methods: {
    imageView(img) {
      return img ? QNImageUtil.imageView(img) : ''
    },
    async fetchInfo() {
      if (!this.matchId) return
      this.loading = true
      try {
        const [signupRes, couponRes] = await Promise.all([
          getBMMatchTeamSignup({
            matchId: this.matchId,
            teamId: this.teamId
          }),
          getMyMatchPlayerSignupCouponTicketList({
            matchId: this.matchId,
            teamId: this.teamId,
            playerId: this.playerId
          }).catch(() => ({ data: { list: [] } }))
        ])

        const data = (signupRes && signupRes.data) || {}
        this.match = data.match || {}
        this.team = data.team || {}
        const players = data.players || []
        this.player = players.find(p => String(p.id) === String(this.playerId)) || {}

        const feeAmount = this.player.feeAmount ?? data.feeAmount ?? this.match.feeAmount
        const registerPrice = this.player.registerPrice ?? data.registerPrice ?? this.match.registerPrice
        const raw = feeAmount != null ? feeAmount : registerPrice
        const fen = Number(raw)
        this.amountFen = Number.isFinite(fen) ? fen : 0

        const couponData = (couponRes && couponRes.data) || {}
        this.couponList = couponData.list || couponData || []
        if (this.couponList.length === 0 && this.payMethod === 'discount') {
          this.payMethod = 'wechat'
        }
      } catch (e) {
        Toast.fail(e?.message || '获取支付信息失败')
      } finally {
        this.loading = false
      }
    },
    buildSuccessRedirectUrl(orderId) {
      const base = `${window.location.origin}${window.location.pathname}`
      const qs = UrlUtil.queryObjectToString({
        orderId,
        matchId: this.matchId,
        teamId: this.teamId,
        playerId: this.playerId,
        unionMatchId: this.match.unionMatchId || this.matchId
      })
      return `${base}#/entry-page/payment-success?${qs}`
    },
    async onPay() {
      try {
        const params = {
          matchId: this.matchId,
          teamId: this.teamId,
          playerId: this.playerId
        }
        if (this.payMethod === 'discount') {
          const firstCouponId =
            this.couponList[0] && (this.couponList[0].id != null ? this.couponList[0].id : this.couponList[0].ticketId)
          if (!firstCouponId) {
            Toast('暂无可用参赛券，请选择其他支付方式')
            return
          }
          params.couponTicketIds = String(firstCouponId)
        }

        const res = await bangsaishiCreatePlayerSignupOrder(params)
        const orderId = res && res.data && res.data.orderId
        if (!orderId) {
          Toast.fail('创建订单失败')
          return
        }
        this.orderId = orderId
        // 参赛券抵扣：下单后直接视为支付完成，跳转支付成功页
        if (this.payMethod === 'discount') {
          this.$router.replace({
            name: 'ApplyPaymentSuccess',
            query: {
              orderId,
              matchId: this.matchId,
              teamId: this.teamId,
              playerId: this.playerId,
              unionMatchId: this.match.unionMatchId || this.matchId
            }
          })
          return
        }
        // 微信支付：支付完成后的 redirectUrl 统一走支付成功页
        this.redirectUrl = this.buildSuccessRedirectUrl(orderId)
        this.pay()
      } catch (e) {
        Toast.fail(e?.message || '创建订单失败')
      }
    },
    pay() {
      if (!this.orderId) return
      if (AppType.isInWeChat()) {
        isWeChatMiniApp().then(res => {
          if (res) {
            this.miniAppPayOrder(this.orderId)
          } else {
            this.getWechatPrepayInfo()
          }
        })
      } else {
        Toast('请在微信环境打开')
      }
    },
    getWechatPrepayInfo() {
      const wxInfo = getWXInfo()
      if (!wxInfo?.openId) {
        if (AppType.isInWeChat()) {
          removeToken()
          Toast('请刷新页面后重试')
          return
        } else {
          Toast('请在微信环境打开')
          return
        }
      }
      const data = {
        orderId: this.orderId,
        openId: wxInfo.openId,
        realPay: 1
      }
      getWechatPrepayInfo(data).then(res => {
        this.hrefWechatPay(res.data.payInfo.payInfo)
      })
    },
    hrefWechatPay(payInfo) {
      localStorage.removeItem('saas-redirect')
      const redirectUrl = this.redirectUrl || this.buildSuccessRedirectUrl(this.orderId)
      const payUrl =
        ConstConfig.payUrl +
        '?' +
        UrlUtil.queryObjectToString({
          t: Date.now(),
          payInfo: JSON.stringify(payInfo),
          redirectUrl
        })
      window.location.assign(payUrl)
    },
    miniAppPayOrder(orderId) {
      const redirectUrl = this.redirectUrl || this.buildSuccessRedirectUrl(orderId)
      const url = `/pages/pay/index?orderId=${orderId}&redirectUrl=${encodeURIComponent(redirectUrl)}`
      wx.miniProgram.navigateTo({ url })
    }
  }
}
</script>

<style scoped lang="scss">
.payment2 {
  min-height: 100vh;
  background: #f6f6f8;
  padding: 16px;
  padding-bottom: 88px;
  box-sizing: border-box;
}
.page-title {
  font-size: 16px;
  font-weight: 600;
  color: #1d2129;
  margin-bottom: 12px;
}
.loading {
  padding: 40px 0;
}
.card {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  .card-main {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  }
  .logo {
    width: 56px;
    height: 56px;
    border-radius: 4px;
    overflow: hidden;
    flex-shrink: 0;
    background: #e8e8e8;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .info {
    flex: 1;
    margin-left: 12px;
    .name {
      font-size: 16px;
      font-weight: 600;
      color: #1d2129;
      line-height: 22px;
    }
    .minor {
      margin-top: 6px;
      font-size: 13px;
      color: #606266;
    }
  }
  .kv {
    .row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0;
      border-top: 1px solid #f1f1f1;
      &:first-child {
        border-top: none;
      }
      .label {
        font-size: 13px;
        color: #606266;
        flex-shrink: 0;
        margin-right: 12px;
      }
      .value {
        font-size: 13px;
        color: #1d2129;
        text-align: right;
        flex: 1;
        min-width: 0;
      }
      .price {
        color: #bc2d2f;
        font-weight: 600;
      }
    }
  }
}
.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #1d2129;
  margin: 14px 0 10px;
}
.pay-methods {
  .van-cell-group--inset{
    margin: 0;
  }
  .cell-title {
    display: flex;
    align-items: center;
    gap: 10px;
    .pm-icon {
      width: 20px;
      height: 20px;
      border-radius: 4px;
      background: #e8e8e8;
      &.placeholder {
        display: inline-block;
      }
    }
    .minor-text {
      font-size: 12px;
      color: #86909c;
      margin-left: 6px;
    }
  }
}
.bottom-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 12px 16px;
  padding-bottom: calc(12px + env(safe-area-inset-bottom));
  background: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: space-between;
  .sum {
    font-size: 13px;
    color: #606266;
    .sum-value {
      color: #1d2129;
      font-weight: 600;
      margin-left: 6px;
    }
  }
  .pay-btn {
    width: 120px;
    height: 44px;
    border-radius: 22px;
    border: none;
  }
}
</style>
